import Icon from 'antd/lib/icon';
import * as React from 'react';
const FCLModeSvg = ({strokeColor, ...rest}) => {
  return (
    <svg {...rest} width="16px" height="9px" viewBox="0 0 16 9" version="1.1">
        <g stroke={strokeColor || '#666'} id="Group-50" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect id="Rectangle" x="0.5" y="0.5" width="15" height="8"></rect>
            <line x1="3.5" y1="2.5" x2="3.5" y2="6.5" id="Line" stroke-linecap="square"></line>
            <line x1="6.5" y1="2.5" x2="6.5" y2="6.5" id="Line-7" stroke-linecap="square"></line>
            <line x1="9.5" y1="2.5" x2="9.5" y2="6.5" id="Line-2" stroke-linecap="square"></line>
            <line x1="12.5" y1="2.5" x2="12.5" y2="6.5" id="Line-3" stroke-linecap="square"></line>
        </g>
    </svg>
  );
};

const FCLModeIconBlack = props => (
  <Icon component={(innerProps) => {
    return FCLModeSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);
export default FCLModeIconBlack;
